// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"ParticipantSearch_searchInputWrapper__aLjek","searchInput":"ParticipantSearch_searchInput__Hs+tX","blankBlock":"ParticipantSearch_blankBlock__VFNEh"};